import { TimelineData } from "../models/ReferralRequestor";

export enum EligibilityCheckDispatchTypes {
  CHECK_ELIGIBILITY_ERROR = "CHECK_ELIGIBILITY_ERROR",
  CHECK_ELIGIBILITY_INVOKE = "CHECK_ELIGIBILITY_INVOKE",
  CHECK_ELIGIBILITY_RESET = "CHECK_ELIGIBILITY_RESET",
  CHECK_ELIGIBILITY_SUCCESS = "CHECK_ELIGIBILITY_SUCCESS",
}

export enum EligibilityInformationActionDispatchTypes{
  SET_ELIGIBILITY_INFORMATION_INVOKE = "SET_ELIGIBILITY_INFORMATION_INVOKE",
  SET_ELIGIBILITY_INFORMATION_SUCCESS = "SET_ELIGIBILITY_INFORMATION_SUCCESS"
}

export enum ReferralRequestorActionDispatchTypes {
  REFERRAL_REQUESTOR_INVOKE = "REFERRAL_REQUESTOR_INVOKE",
  REFERRAL_REQUESTOR_SUCCESS = "REFERRAL_REQUESTOR_SUCCESS"
}

export const formInitialState = {
  lastName: "",
  firstName: "",
  email: "",
  isPrivacyCheck: false,
};

export const TimelineInfo: TimelineData[] = [
  { id: 1, label: "Check Eligibility" },
  { id: 2, label: "Referral Details" },
];

export const HealthPlanInitialData = {
  label: "",
  value: "",
  healthPlanId: 0,
  healthPlanName: "",
};

export const HealthPlanData = {
  label: "",
  value: "",
};

export const eligibilityFormInitialState = {
  lastName: "",
  firstName: "",
  dateOfBirth: null,
  subscriberId: "",
  healthPlan: null,
};

export enum EligibilityStatus {
  STATUS_TRUE = "True ",
  STATUS_FALSE = "false",
  STATUS_NULL = "null",
  STATUS_TRUE_WITHOUT_SPACE = "True",
}

export const EligibilityStatusNull = null;
